module.exports = __webpack_public_path__ + "static/media/industria-tour.2188c463.jpg";